// extracted by mini-css-extract-plugin
module.exports = {"PhoneItemContainer":"WhyTeachOnTakbir_PhoneItemContainer__aQg0p","PhoneItemBody":"WhyTeachOnTakbir_PhoneItemBody__oQaIy","cardImg":"WhyTeachOnTakbir_cardImg__bhG_3"};